import React, { useEffect, useState } from "react";
import { getMonthlyReports, lockFinance } from "../../services/ManagementService";
import { useAppContext } from "../../share-components/AppContext";
import { useNavigate } from "react-router-dom";
import FormTitle from "../../share-components/FormTitle";
import SearchColumnSelect from "../../share-components/SearchColumnSelect";
import CustomTable from "../../share-components/CustomTable";
import { currentMonth, currentYear, customStorage, formatDateTime, getAvailableMonths, getChangingSelectColor, getInitialAndCurrentYearMonth, getNextYearMonth, getPayloadData, 
    handleFromMonthChange, handleFromYearChange, handleToMonthChange, handleToYearChange, isNullOrEmptyString, years } from "../../services/UtilityService";
import { SERVER_ERROR_MESSAGE, TOKEN_SESSION_KEY } from "../../constants/commonConstants";
import ConfirmDialog from "../../share-components/ConfirmDialog";
import AlertDialog from "../../share-components/AlertDialog";
import { Button, Card } from "react-bootstrap";
import { getAllActiveUsers } from "../../services/CommonService";
import NoDataFound from "../../share-components/NoDataFound";
import { getSendItemHistories } from "../../services/InstockAdjustmentService";

const SendItemHistories = () => {
    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const [sendItemHistories, setSendItemHistories] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);

    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    const currentUser = getPayloadData(token);

    const [fromYear, setFromYear] = useState(currentYear);
    const [fromMonth, setFromMonth] = useState(currentMonth);
    const [toYear, setToYear] = useState(currentYear);
    const [toMonth, setToMonth] = useState(currentMonth);
    const [afterGetDataStore, setAfterGetDataStore] = useState({
        fromYear: currentYear,
        fromMonth: currentMonth,
        toYear: currentYear,
        toMonth: currentMonth,
    });

    const fetchSendItemHistories = async () => {
        try {
            setLoading(true);
            const formData = {
                fromYear: fromYear,
                fromMonth: fromMonth,
                toYear: toYear,
                toMonth: toMonth
            }
            const response = await getSendItemHistories(formData);
            const result = (response?.result || []).map(data=> ({
                ...data,
                colorSizeInfo: getColorSizeInfo(data), 
                formatedSendItemDateTime: formatDateTime(data.sendDateTime)
            }));
            setSendItemHistories(result);
            const afterFetchStore = {
                fromYear,
                fromMonth,
                toYear,
                toMonth,
            }
            setAfterGetDataStore(afterFetchStore);
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const getColorSizeInfo = (data) => {
        const color = !isNullOrEmptyString(data?.color) ? data?.color : "";
        const size = !isNullOrEmptyString(data?.size) ? data?.size : "";

        const result = `${!isNullOrEmptyString(color) ? '[' + color +'] ' : ''} ${!isNullOrEmptyString(size) ? '[' + size +'] ' : ''}`;
        return result;
    }

    const fetchInitialLoad = async () => {
        await fetchSendItemHistories();
    }

    useEffect(() => {
        setRouteNaviData("STOCK >> STOCK TRANSFER HISTORIES");
        fetchInitialLoad();
    }, []);

    const columns = [
        {
            Header: 'User From',
            accessor: 'sendFromUserBy',
            style: {
                maxWidth: "200px",
                verticalAlign: "middle"
            }
        },
        {
            Header: 'User To',
            accessor: 'sendToUserBy',
            style: {
                maxWidth: "200px",
                verticalAlign: "middle"
            }
        },
        {
            Header: 'Product Name',
            accessor: 'productName',
            style: {
                maxWidth: "200px",
                verticalAlign: "middle"
            }
        },
        {
            Header: 'Color/Size',
            accessor: 'colorSizeInfo',
            style: {
                maxWidth: "350px",
                verticalAlign: "middle"
            }
        },
        {
            Header: 'Send Quantity',
            accessor: 'sendItemCount',
            style: {
                maxWidth: "200px",
                verticalAlign: "middle",
                fontWeight: 'bold'
            }
        },
        {
            Header: 'Brand Name',
            accessor: 'brandName',
            style: {
                maxWidth: "200px",
                verticalAlign: "middle"
            }
        },
        {
            Header: 'Category Name',
            accessor: 'categoryName',
            style: {
                maxWidth: "200px",
                verticalAlign: "middle"
            }
        },
        {
            Header: 'Send Date Time',
            accessor: 'formatedSendItemDateTime',
            style: {
                maxWidth: "200px",
                verticalAlign: "middle"
            }
        },
    ];

    return (
        <div id='sendStockHistoriesPage'>
            <FormTitle title={"Stock Transfer Histories"} isCenter={true} />
            {isFirstLoaded && <>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {afterGetDataStore?.fromYear}/{afterGetDataStore?.fromMonth} ～ {afterGetDataStore?.toYear}/{afterGetDataStore?.toMonth}
                </div>
                <div style={{ overflow: "auto", paddingBottom: "50px" }}>
                    <div style={{ minWidth: "max-content", maxWidth: "850px", margin: '0 auto' }}>
                        <Card>
                            <Card.Body style={{
                                padding: '10px 5px 20px 5px'
                            }}>
                                <div>
                                    <div>
                                        <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                            {/* From Year & Month */}
                                            <div className="d-inline">
                                                <label className="me-1 custom-label" htmlFor="fromYear" style={{ minWidth: "50px" }}>
                                                    From
                                                </label>
                                                <div>
                                                    <select
                                                        id="fromYear"
                                                        className={`customInputControl ${getChangingSelectColor(fromYear, afterGetDataStore?.fromYear)}`}
                                                        value={fromYear}
                                                        onChange={(e) => handleFromYearChange(e, fromMonth, toYear, toMonth, setFromYear, setFromMonth, setToYear, setToMonth)}
                                                    >
                                                        {years.map((year) => (
                                                            <option key={year} value={year}>{year}</option>
                                                        ))}
                                                    </select>
                                                    <span className="separator">/</span>
                                                    <select
                                                        id="fromMonth"
                                                        className={`customInputControl ${getChangingSelectColor(fromMonth, afterGetDataStore?.fromMonth)}`}
                                                        value={fromMonth}
                                                        onChange={(e) => handleFromMonthChange(e, fromYear, toYear, toMonth, setFromMonth, setToMonth)}
                                                    >
                                                        {getAvailableMonths(fromYear).map((month) => (
                                                            <option key={month} value={month}>
                                                                {month.toString().padStart(2, "0")}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* To Year & Month */}
                                            <div className="d-inline">
                                                <label className="me-1 custom-label" htmlFor="toYear" style={{ minWidth: "50px" }}>
                                                    To
                                                </label>
                                                <div>
                                                    <select
                                                        id="toYear"
                                                        className={`customInputControl ${getChangingSelectColor(toYear, afterGetDataStore?.toYear)}`}
                                                        value={toYear}
                                                        onChange={(e) => handleToYearChange(e, fromYear, fromMonth, toMonth, setFromYear, setToYear, setFromMonth)}
                                                    >
                                                        {years.map((year) => (
                                                            <option key={year} value={year}>{year}</option>
                                                        ))}
                                                    </select>
                                                    <span className="separator">/</span>
                                                    <select
                                                        id="toMonth"
                                                        className={`customInputControl ${getChangingSelectColor(toMonth, afterGetDataStore?.toMonth)}`}
                                                        value={toMonth}
                                                        onChange={(e) => handleToMonthChange(e, fromYear, fromMonth, toYear, setFromMonth, setToMonth)}
                                                    >
                                                        {getAvailableMonths(toYear).map((month) => (
                                                            <option key={month} value={month}>
                                                                {month.toString().padStart(2, "0")}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-inline">
                                            <button type='button' className="btn btn-success btn-sm appBtn"
                                                onClick={fetchSendItemHistories}
                                            >Get Data</button>
                                        </div>
                                        <div style={{ width: "max-content" }}>
                                            <div style={{ marginBottom: '10px', marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'end', flexWrap: 'wrap', gap: '5px' }}>
                                                <div style={{ display: 'inline-block' }}>
                                                    <SearchColumnSelect data={sendItemHistories} setData={setFilteredData} columns={columns} />
                                                </div>
                                            </div>
                                            {filteredData?.length > 0 ?
                                                <CustomTable
                                                    tableId='sendItemHistoriesTbl'
                                                    columns={columns}
                                                    tblData={filteredData || []}
                                                    showPagination={true}
                                                    // initialSortBy={[{ id: 'outOfStockQuantity', desc: true }]}
                                                    itemsPerPage={20}
                                                /> : <NoDataFound />}
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </>}
        </div>
    );
}

export default SendItemHistories;